import {
    downloadFiles,
    downloadMultipleFiles as downloadApplicantMultipleFiles,
    getPath as getApplicantPath,
    searchFiles as searchApplicantFiles,
    uploadFile as uploadApplicantFile
} from 'ROOT/apps/applicant/src/api/files';
import * as applicantTableActions from 'ROOT/apps/applicant/src/services/ui/actions';
import {
    createPath,
    deletePath,
    fileAttachmentMoveMulti,
    fileAttachmentShareContacts,
    fileAttachmentShareMulti,
    getPath,
    getPaths,
    searchFiles,
    updateFileAttachment,
    updatePath
} from 'ROOT/apps/manager/src/api/files';
import { deleteMultipleFiles, updateFile } from 'ROOT/apps/manager/src/api/notesFiles';
import { downloadFile, downloadMultipleFiles } from 'ROOT/apps/manager/src/api/notesFiles';
import { deleteFileAttachment, uploadFile } from 'ROOT/apps/manager/src/api/uploadFiles';
import { allowOwnerShare, allowTenantShare, allowVendorShare } from 'ROOT/apps/manager/src/constants/maintenance/sharedFileAttachments';
import { hasPermission } from 'ROOT/apps/manager/src/services/app';
import * as managerTableActions from 'ROOT/apps/manager/src/services/ui/actions';
import {
    downloadFiles as downloadOwnerFiles,
    downloadMultipleFiles as downloadOwnerMultipleFiles,
    getPath as getOwnerPath,
    searchFiles as searchOwnerFiles,
    uploadFile as uploadOwnerFile
} from 'ROOT/apps/owner/src/api/files';
import * as ownerTableActions from 'ROOT/apps/owner/src/services/ui/actions';
import {
    downloadFiles as downloadResidentFiles,
    downloadMultipleFiles as downloadResidentMultipleFiles,
    getPath as getResidentPath,
    searchFiles as searchResidentFiles,
    uploadFile as uploadResidentFile
} from 'ROOT/apps/resident/src/api/files';
import * as residentTableActions from 'ROOT/apps/resident/src/services/ui/actions';
import {
    downloadFiles as downloadVendorFiles,
    downloadMultipleFiles as downloadVendorMultipleFiles,
    getPath as getVendorPath,
    searchFiles as searchVendorFiles,
    uploadFile as uploadVendorFile
} from 'ROOT/apps/vendor-portal/src/api/files';
import * as vendorTableActions from 'ROOT/apps/vendor-portal/src/services/ui/actions';

import PortalTypes from 'Lib/constants/app/portalTypes';

const managerApis = {
    getPath: getPath,
    getPaths: getPaths,
    searchFiles: searchFiles,
    createPath: createPath,
    updatePath: updatePath,
    deletePath: deletePath,
    deleteFileAttachment: deleteFileAttachment,
    uploadFile: uploadFile,
    updateFile: updateFile,
    updateFileAttachment: updateFileAttachment,
    deleteMultipleFiles: deleteMultipleFiles,
    fileAttachmentShareMulti: fileAttachmentShareMulti,
    fileAttachmentMoveMulti: fileAttachmentMoveMulti,
    fileAttachmentShareContacts: fileAttachmentShareContacts,
    downloadFile: downloadFile,
    downloadMultipleFiles: downloadMultipleFiles,
    allowOwnerShare: allowOwnerShare,
    allowTenantShare: allowTenantShare,
    allowVendorShare: allowVendorShare,
    hasPermission: hasPermission,
    tableActions: managerTableActions
};

const vendorApis = {
    getPath: getVendorPath,
    searchFiles: searchVendorFiles,
    uploadFile: uploadVendorFile,
    downloadFile: downloadVendorFiles,
    downloadMultipleFiles: downloadVendorMultipleFiles,
    tableActions: vendorTableActions
};

const applicantApis = {
    getPath: getApplicantPath,
    searchFiles: searchApplicantFiles,
    uploadFile: uploadApplicantFile,
    downloadFile: downloadFiles,
    downloadMultipleFiles: downloadApplicantMultipleFiles,
    tableActions: applicantTableActions
};

const residentApis = {
    getPath: getResidentPath,
    searchFiles: searchResidentFiles,
    uploadFile: uploadResidentFile,
    downloadFile: downloadResidentFiles,
    downloadMultipleFiles: downloadResidentMultipleFiles,
    tableActions: residentTableActions
};

const ownerApis = {
    getPath: getOwnerPath,
    searchFiles: searchOwnerFiles,
    uploadFile: uploadOwnerFile,
    downloadFile: downloadOwnerFiles,
    downloadMultipleFiles: downloadOwnerMultipleFiles,
    tableActions: ownerTableActions
};

export const getApiByPortalType = portalTypeID => {
    switch (portalTypeID) {
        case PortalTypes.Manager:
            return managerApis;
        case PortalTypes.Vendor:
            return vendorApis;
        case PortalTypes.Applicant:
            return applicantApis;
        case PortalTypes.Tenant:
            return residentApis;
        case PortalTypes.Owner:
            return ownerApis;
        default:
            return {};
    }
};
